var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.535 5C7.698 5 7 5.7 7 6.537v18.928C7 26.302 7.698 27 8.535 27h15.37c.837 0 1.535-.698 1.535-1.535l.001-14.32h-5.374a.781.781 0 01-.772-.765V5H8.535zm11.7 14.235a1 1 0 011 1v.589a1 1 0 01-1 1h-8.353a1 1 0 01-1-1v-.589a1 1 0 011-1h8.353zm0-5.176a1 1 0 011 1v.588a1 1 0 01-1 1h-8.353a1 1 0 01-1-1v-.588a1 1 0 011-1h8.353zM20.831 5c.286 0 .381.064.593.276l3.786 3.788a.763.763 0 01.231.545h-4.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.0d7eeb4ca6db19e51aff8b8ee35c6ea3.svg";
export { ForwardRef as ReactComponent };